import { useTranslation } from "react-i18next";
import { useState } from "react";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import css from "../Workflows.module.css";
import UsersListInSpace from "./UsersListInSpace";
import ToggleSwitchComponent from "../../../../../cubeComponent/form/ToggleSwitchComponent";

function AddUserModal({
  spaceId,
  closeModal,
  addUserCallback,
  disabledUserIds = [],
  allowMultiSelection = true,
  checkBoxToAssignUserToTransition,
}) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("Users");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [transitionUsers, setTransitionUsers] = useState(false);

  const selectUsers = (value) => {
    setSelectedUsers(value);
  };

  const activeTabChangeHandler = (e) => {
    const target = e.currentTarget.attributes["data-name"].value;
    setActiveTab(target);
  };

  const onSubmitAction = () => {
    addUserCallback(selectedUsers, transitionUsers);
  };

  const handleToogleSwitch = (args) => {
    setTransitionUsers(args.target.checked);
  };

  const header = () => (
    <div className={css.addUserHeader}>
      <p>{t("Add Users")}</p>
    </div>
  );

  const tabComponent = () => (
    <div className={css.addReviewerTabComponentContainer}>
      <div data-name="Users" className={css.individualTab} onClick={activeTabChangeHandler}>
        <span>{t("Users")}</span>
        <div className={activeTab === "Users" ? css.selectedTab : css.unselectedTab} />
      </div>

      {/* <div data-name="Groups" className={css.individualTab} onClick={activeTabChangeHandler}>
        <span>{t("Groups")}</span>
        <div className={activeTab === 'Groups' ? css.selectedTab : css.unselectedTab} />
      </div>

      <div data-name="Organisations" className={css.individualTab} onClick={activeTabChangeHandler}>
        <span>{t("Organisations")}</span>
        <div className={activeTab === 'Organisations' ? css.selectedTab : css.unselectedTab} />
      </div>

      <div data-name="Positions" className={css.individualTab} onClick={activeTabChangeHandler}>
        <span>{t("Positions")}</span>
        <div className={activeTab === 'Positions' ? css.selectedTab : css.unselectedTab} />
      </div> */}
    </div>
  );

  const content = () => (
    <div className={css.addReviewerContentWrapper}>
      {tabComponent()}
      <div className={css.addReviewerContent}>
        {activeTab === "Users" && (
          <UsersListInSpace
            spaceId={spaceId}
            selectUsers={selectUsers}
            disabledUserIds={disabledUserIds}
            allowMultiSelection={allowMultiSelection}
          />
        )}
      </div>
    </div>
  );

  const footer = () => (
    <div className={css.addReviewerFooter}>
      <div className="flex items-center gap-4">
        <ButtonComponent
          buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          disabled={!selectedUsers.length}
          onClick={onSubmitAction}
        >
          Add
        </ButtonComponent>

        <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeModal}>
          Discard
        </ButtonComponent>

        {checkBoxToAssignUserToTransition && (
          <div className="flex items-center space-inline-2">
            <ToggleSwitchComponent
              id="toggleBtn"
              // checked={!!getSpaceToggle.toggle}
              onChange={handleToogleSwitch}
              data-testid="SpaceToggleButton"
            />
            <label htmlFor="toggleBtn" className="ms-2" data-testid="ShowHiddenItemsText">
              Assign selected user(s) to associated transitions
            </label>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className={css.addReviewerContainer}>
      <ModalStateDialogComponent
        width="1200px"
        headerTitle={header()}
        modelContent={content()}
        footerContent={footer()}
        allowModalPadding={false}
        onCancel={closeModal}
        isVisible
        zIndex={30000}
      />
    </div>
  );
}

export default AddUserModal;
